import React, { useState, useEffect } from 'react';
import {
  checkVersionUpdate,
  updateStoredVersion,
  performVersionBasedUpdates,
  getUpdateMessage
} from '../utils/version';

// Funzione per forzare l'aggiornamento di tutti i Service Worker registrati
// unregisterServiceWorkers rimossa (inutilizzata)

/**
 * Componente che gestisce gli aggiornamenti dell'app basati sulla versione
 * Mostra un alert all'utente quando l'app è stata aggiornata
 */
const VersionUpdateAlert = () => {
  const [showUpdateAlert, setShowUpdateAlert] = useState(false);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkForUpdates = async () => {
      try {
        // Verifica se è necessario un aggiornamento all'avvio dell'app
        const versionInfo = await checkVersionUpdate();

        if (versionInfo.needsUpdate) {
          console.log('Rilevato aggiornamento versione:', versionInfo);

          // Esegui aggiornamenti specifici per questa versione
          performVersionBasedUpdates(versionInfo.oldVersion, versionInfo.currentVersion);

          // Aggiorna la versione memorizzata
          updateStoredVersion();

          // Mostra l'alert di aggiornamento solo se non è stato forzato il ricaricamento
          if (!versionInfo.isNewBuild) {
            setMessage(getUpdateMessage(versionInfo));
            setShowUpdateAlert(true);
          }

          // Se c'è un errore o se è un nuovo build, forziamo la pulizia
          // Rimosso reload forzato automatico per evitare loop
          if (versionInfo.error || versionInfo.isNewBuild) {
            console.log('Nuovo build o errore rilevato: attesa azione utente.');
            // await unregisterServiceWorkers(); // Opzionale: pulire cache in background
            // NON chiamare window.location.reload() qui
          }
        }
      } catch (error) {
        console.error('Errore durante il controllo degli aggiornamenti:', error);

        // In caso di errore, NON forziamo il reload
        console.log('Tentativo di aggiornamento fallito, riproveremo più tardi.');
        // await unregisterServiceWorkers();
        // window.location.reload(true); // DISABILITATO
      } finally {
        setIsLoading(false);
      }
    };

    // Verifica gli aggiornamenti all'avvio
    checkForUpdates();

    // Aggiungi un listener per i messaggi dal service worker
    const handleServiceWorkerMessage = (event) => {
      if (event.data && event.data.type === 'NEW_VERSION_AVAILABLE') {
        console.log('Nuova versione disponibile:', event.data.version);
        // NON fare reload automatico - l'utente può cliccare "Aggiorna" nell'alert
        setMessage(`Nuova versione ${event.data.version} disponibile!`);
        setShowUpdateAlert(true);
      }
    };

    navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);

    // Verifica gli aggiornamenti ogni 5 minuti
    const intervalId = setInterval(checkForUpdates, 5 * 60 * 1000);

    // Pulisci l'interval quando il componente viene smontato
    return () => {
      clearInterval(intervalId);
      navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
    };
  }, []);

  // Se stiamo ancora caricando, non mostrare nulla
  if (isLoading) return null;

  const handleDismiss = async () => {
    try {
      // Forza l'aggiornamento del service worker
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      // Forza il ricaricamento della pagina
      window.location.reload(true);
    } catch (error) {
      console.error('Errore durante l\'aggiornamento:', error);
      setShowUpdateAlert(false);
    }
  };

  if (!showUpdateAlert) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '60px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '90%',
        maxWidth: '500px',
        backgroundColor: '#1976d2',
        color: 'white',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
      }}
    >
      <div style={{ marginBottom: '12px' }}>
        <span role="img" aria-label="aggiornamento" style={{ fontSize: '24px', marginRight: '8px' }}>
          🔄
        </span>
        <strong>Aggiornamento completato</strong>
      </div>

      <p style={{ margin: '0 0 16px 0' }}>{message}</p>

      <button
        onClick={handleDismiss}
        style={{
          backgroundColor: 'white',
          color: '#1976d2',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '4px',
          fontWeight: 'bold',
          cursor: 'pointer'
        }}
      >
        Ho capito
      </button>
    </div>
  );
};

export default VersionUpdateAlert;
